import { useState, useEffect } from "react";
import UiButton from "../../common/UiButton/UiButton";
import {
  Drawer,
  Input,
  Row,
  Col,
  Table,
  notification,
  DatePicker,
  Select,
} from "antd";
import "./Style.css";
import moment from "moment";
import {
  searchLeadDetails,
  getDropdownList,
} from "../../redux/GlobalSearch/action";
import { connect } from "react-redux";
import useSession from "../CustomLogout/useSession";
import { useNavigate } from "react-router-dom";

const { Option } = Select;

const GlobalLeadSearch = (props) => {
  const [open, setOpen] = useState(false);
  const [searchText, setSearchText] = useState(null);
  const [selectedStatus, setSelectedStatus] = useState(null);
  const [getStatus, setGetStatus] = useState(null);
  const [selectedDate, setSelectedDate] = useState();
  const [filteredData, setFilteredData] = useState(null);
  const handleSessionExpired = useSession();
  const [noData, setNoData] = useState(false);
  const history = useNavigate();
  const [datePickerKey, setDatePickerKey] = useState(0);

  useEffect(() => {
    props
      .getDropdownList({
        access_token: props.auth?.accessToken?.access_token,
      })
      .then((res) => {
        if (res?.status === 200) {
          setGetStatus(res?.data?.LeadStatus);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
          }
        }
      });
  }, []);

  const statusData =
    getStatus?.length > 0
      ? getStatus.map((el) => {
          return {
            label: el.name,
            value: el.value,
          };
        })
      : [];

  const handleAddEvent = () => {
    setOpen(true);
    setNoData(false);
  };

  const handleStatusMenuClick = (type) => {
    setSelectedStatus(type);
  };

  const handleDateChange = (date, dateString) => {
    setSelectedDate(moment(dateString, "YYYY-MM-DD"));
  };

  const onClose = () => {
    setOpen(false);
    setSearchText(null);
    setSelectedDate(null);
    setSelectedStatus(null);
    setFilteredData(null);
    setDatePickerKey(datePickerKey + 1);
  };

  const handleSearch = () => {
    const foundDataArray = [];
    const searchData = {
      search: searchText ?? null,
      partnerLeadType: "PARTNER",
      partnerLeadStatus: selectedStatus ?? null,
      time: selectedDate ?? null,
    };

    props
      .searchLeadDetails({
        access_token: props.auth?.accessToken?.access_token,
        values: searchData,
      })
      .then((res) => {
        if (res && res.status === 200) {
          for (const PartnerLeadStatus in res?.data?.dto) {
            if (res?.data?.dto.hasOwnProperty(PartnerLeadStatus)) {
              const leadStatus =
                res?.data?.dto[PartnerLeadStatus]?.PartnerLeadStatus;
              const leadDataArray =
                res?.data?.dto[PartnerLeadStatus]?.PartnerLeadData || [];

              if (leadDataArray.length > 0) {
                foundDataArray.push({
                  PartnerLeadStatus: leadStatus,
                  PartnerLeadData: leadDataArray,
                });
              }
            }
          }

          setFilteredData(foundDataArray);
          setNoData(false);
        }
        if (res?.data?.error || res.message) {
          const errorCode = res?.data?.error?.errorCode || res.errorCode;
          const errorMessage = res?.data?.error?.message || res.message;

          if (errorCode === "403" && res?.data?.error?.logoutStatus) {
            handleSessionExpired();
          } else {
            notification.error({
              description: errorMessage,
              duration: 5,
              placement: "top",
            });
            setFilteredData(null);
            setNoData(true);
          }
        }
      });
  };

  const handleRowClick = (leadId) => {
    history(`/leadManagementDashboard/view-lead`, {
      state: { leadId: leadId },
    });
  };

  const columns = [
    {
      title: "Lead Code",
      dataIndex: "leadCode",
      key: "leadCode",
      render: (text) => text || "- - - -",
    },
    {
      title: "Lead Full Name",
      dataIndex: "leadFullName",
      key: "leadFullName",
      render: (text) => text || "- - - -",
    },
    {
      title: "Created On",
      dataIndex: "createdOn",
      key: "createdOn",
      render: (timestamp) => moment(timestamp).format("yyyy-MM-DD"),
    },
    {
      title: "Pincode",
      dataIndex: "leadPincode",
      key: "leadPincode",
      render: (text) => text || "- - - -",
    },
    {
      title: "CRM Lead ID",
      dataIndex: "leadCrmId",
      key: "leadCrmId",
      render: (text) => text || "- - - -",
    },
    {
      title: "Avance Branch",
      dataIndex: "assignedAvanseBranchName",
      key: "assignedAvanseBranchName",
      render: (text) => text || "- - - -",
    },
  ];

  return (
    <div>
      <UiButton onClick={handleAddEvent} title="ADVANCE SEARCH" />

      <Drawer
        title="Basic Drawer"
        placement="right"
        onClose={onClose}
        open={open}
        className="search-lead-drawer"
      >
        <div className="addpartnerheading pan-sec-res forline">
          <div>
            <h2 className="main-heading">Advance Search</h2>
            <div className="headre-line newHeadre"></div>
          </div>
          <h3 onClick={onClose} className="header-small-text">
            Cancel
          </h3>
        </div>
        <div className="Parennt">
          <Row md={12}>
            <Col className="NeewProp" md={20}>
              <Col md={15} sm={17}>
                <Input
                  className="custom-input"
                  placeholder="Search"
                  value={searchText}
                  onChange={(e) =>
                    setSearchText(e.target.value === "" ? null : e.target.value)
                  }
                  onPressEnter={handleSearch}
                  bordered={false}
                />
              </Col>
              <Col md={4} sm={3} className="Marg-top">
                <Select
                  style={{ width: 135 }}
                  placeholder="Select Status  ˅"
                  value={selectedStatus}
                  onChange={handleStatusMenuClick}
                  popupClassName="custom-dropdown-menu"
                  suffixIcon={null}
                  allowClear={true}
                  bordered={false}
                >
                  {statusData.map((status, index) => (
                    <Option
                      key={index}
                      value={status.value}
                      style={{ fontSize: "12px", color: "#a8a8a8" }}
                    >
                      {status.label}
                    </Option>
                  ))}
                </Select>
              </Col>
              <Col md={4} sm={4} className="Marg-top">
                <DatePicker
                  key={datePickerKey}
                  placeholder="Select Date  ˅"
                  bordered={false}
                  onChange={handleDateChange}
                  suffixIcon={false}
                  inputReadOnly
                />
              </Col>
            </Col>
            <Col md={3} className="newButton">
              <UiButton onClick={handleSearch} type="submit" title="SEARCH" />
            </Col>
          </Row>
        </div>
        {filteredData !== null && filteredData.length > 0 ? (
          <div>
            {filteredData.map((data, index) => (
              <div key={index}>
                <p className="StatusName">{data?.PartnerLeadStatus}</p>

                {data?.PartnerLeadData?.length > 0 ? (
                  <Table
                    columns={columns}
                    dataSource={data?.PartnerLeadData}
                    pagination={false}
                    bordered={false}
                    rowClassName={() => "row-pointer"}
                    onRow={(record) => ({
                      onClick: () => handleRowClick(record?.leadId),
                    })}
                  />
                ) : (
                  <p>No Leads Found.</p>
                )}
                <div className="Line"></div>
              </div>
            ))}
          </div>
        ) : (
          noData && <p>No Matching Leads Found.</p>
        )}
      </Drawer>
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    searchLeadDetails: (data) => dispatch(searchLeadDetails(data)),
    getDropdownList: (data) => dispatch(getDropdownList(data)),
  };
};

const mapStateToProps = (state) => {
  return {
    auth: state.auth,
    state: state && state.auth,
    access_token: state && state.auth && state.auth.idToken,
    LogoutFlag: state.Logout,
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(GlobalLeadSearch);
